const Divider: React.FC = () => {
  return (
    <div className="w-full h-1 md:w-1 md:h-full bg-white/20 relative rounded-md mt-5">
      <div className="absolute top-1/2 -translate-y-1/2 bottom-0 right-0 bg-white w-3/4 left-1/2 -translate-x-1/2 rounded-md h-1/2"></div>
    </div>
  );
};

export default Divider;
